import { render, staticRenderFns } from "./FundDocs.html?vue&type=template&id=669862da&"
import script from "./FundDocs.ts?vue&type=script&lang=ts&"
export * from "./FundDocs.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/fund-docs/_docs.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports